
const dark = require('./dark/tokens.common')
const light = require('./light/tokens.common')
module.exports.dark = dark
module.exports.light = light
